import { useDeleteTourMutation } from '#api-bridge/tourApi.ts';

export const useCancelTour = () => {
    const [deleteTour, { isLoading }] = useDeleteTourMutation();
    const cancelTour = async (tourId: string) => {
        return deleteTour(tourId)
            .unwrap()
            .then(() => {
                return true;
            })
            .catch(e => {
                console.error(`Failed to cancel tour ${tourId}`, e);
                return false;
            });
    };
    return { cancelTour, isLoading };
};
